interface LoadingStateProps {
  text?: string;
}

export function LoadingState({ text = '内容加载中…' }: LoadingStateProps) {
  return (
    <div className="w-full py-20 flex flex-col items-center justify-center gap-4">
      <span className="w-10 h-10 border-2 border-background-300 border-t-primary-500 rounded-full animate-spin" />
      <p className="text-sm text-foreground-600">{text}</p>
    </div>
  );
}

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: string;
}

export function EmptyState({ title, description, icon = 'ri-inbox-line' }: EmptyStateProps) {
  return (
    <div className="w-full py-20 flex flex-col items-center justify-center text-center gap-3">
      <span className="w-14 h-14 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-500">
        <i className={`${icon} text-2xl`} />
      </span>
      <p className="text-base font-medium text-foreground-800">{title}</p>
      {description && <p className="max-w-md text-sm text-foreground-500">{description}</p>}
    </div>
  );
}

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message = '网络似乎出了点问题，请稍后重试', onRetry }: ErrorStateProps) {
  return (
    <div className="w-full py-20 flex flex-col items-center justify-center text-center gap-3">
      <span className="w-14 h-14 rounded-full bg-primary-500/12 flex items-center justify-center text-primary-400">
        <i className="ri-error-warning-line text-2xl" />
      </span>
      <p className="text-base font-medium text-foreground-800">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 px-5 py-2 rounded-md bg-primary-500 text-background-950 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          重新加载
        </button>
      )}
    </div>
  );
}